(function () {
  'use strict';

  function setText(selector, value) {
    var nodes = document.querySelectorAll(selector);
    if (!nodes.length) {
      return;
    }

    nodes.forEach(function (node) {
      node.textContent = value;
    });
  }

  function applyAddToPackAvailability(available) {
    var addWraps = document.querySelectorAll('[data-ppv2-add-wrap]');

    addWraps.forEach(function (wrap) {
      wrap.dataset.available = available ? 'true' : 'false';

      var button = wrap.querySelector('button[data-add-to-pack]');
      if (!button) {
        return;
      }

      if (available) {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      } else {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      }
    });
  }

  function applyVariantId(variantId) {
    var addWraps = document.querySelectorAll('[data-ppv2-add-wrap]');

    addWraps.forEach(function (wrap) {
      wrap.dataset.variantId = String(variantId);
    });
  }

  function hydrateSellingPlanMap() {
    var el = document.querySelector('[data-ppv2-selling-plans]');
    if (!el) {
      return {};
    }

    try {
      var parsed = JSON.parse(el.textContent || '{}');
      window.personalised = window.personalised || {};
      window.personalised.sellingPlans = window.personalised.sellingPlans || {};

      Object.keys(parsed).forEach(function (variantIdStr) {
        var plans = parsed[variantIdStr] || {};
        window.personalised.sellingPlans[variantIdStr] = plans;

        var variantIdInt = parseInt(variantIdStr, 10);
        if (!isNaN(variantIdInt)) {
          window.personalised.sellingPlans[variantIdInt] = plans;
        }
      });

      return parsed;
    } catch (error) {
      console.warn('[ppv2] Could not parse selling plans map:', error);
      return {};
    }
  }

  function updateVariantPresentation(option) {
    if (!option) {
      return;
    }

    var variantId = option.value;
    var isAvailable = option.dataset.available === 'true';
    var monthlyPriceText = option.dataset.priceFormatted || '';
    var dailyPriceText = option.dataset.dailyFormatted || '';

    if (monthlyPriceText) {
      setText('[data-ppv2-monthly-price]', monthlyPriceText);
      setText('[data-ppv2-sticky-monthly-price]', monthlyPriceText);
    }
    if (dailyPriceText) {
      setText('[data-ppv2-daily-pill-price]', dailyPriceText);
      setText('[data-ppv2-sticky-daily-price]', dailyPriceText);
    }

    applyVariantId(variantId);
    applyAddToPackAvailability(isAvailable);
  }

  function syncVariantSelectInteractivity() {
    var select = document.querySelector('[data-ppv2-variant-select]');
    if (!select) {
      return;
    }

    var addWrap = document.querySelector('[data-ppv2-add-wrap]');
    var productId = addWrap && addWrap.dataset ? addWrap.dataset.productId : null;
    var bundleApi = window.personalised && window.personalised.bundle;
    var isInBundle = false;

    if (productId && bundleApi && typeof bundleApi.isProductInBundle === 'function') {
      isInBundle = !!bundleApi.isProductInBundle(productId);
    }

    select.disabled = isInBundle;
    if (isInBundle) {
      select.setAttribute('aria-disabled', 'true');
    } else {
      select.removeAttribute('aria-disabled');
    }
  }

  function bindBundleStateListeners() {
    var eventBus = window.personalised && window.personalised.eventBus;
    if (!eventBus || typeof eventBus.on !== 'function') {
      return;
    }

    eventBus.on('bundleStateLoaded', syncVariantSelectInteractivity);
    eventBus.on('bundleStateSaved', syncVariantSelectInteractivity);
  }

  function initVariantPicker() {
    var select = document.querySelector('[data-ppv2-variant-select]');
    if (!select) {
      return;
    }

    hydrateSellingPlanMap();

    var currentOption = select.options[select.selectedIndex];
    updateVariantPresentation(currentOption);
    syncVariantSelectInteractivity();

    select.addEventListener('change', function () {
      var selectedOption = select.options[select.selectedIndex];
      updateVariantPresentation(selectedOption);
    });
  }

  function applyQuizCtaVisibility() {
    var banners = document.querySelectorAll('[data-ppv2-quiz-cta], [data-ppv2-quiz-cta-strip]');
    if (!banners.length) {
      return true;
    }

    function setQuizCtasHidden(hidden) {
      banners.forEach(function (banner) {
        banner.hidden = hidden;
      });
    }

    var userState = window.personalised && window.personalised.userState;
    if (!userState || typeof userState.hasReco === 'undefined') {
      // personalised-user-state.js is not loaded on the PDP template.
      // Fall back to reading localStorage directly so new customers
      // (no vitable_recommended_products) see the quiz CTA.
      try {
        var hasRecoLocal = !!localStorage.getItem('vitable_recommended_products');
        setQuizCtasHidden(hasRecoLocal);
      } catch (e) {
        // localStorage unavailable — show the banner (safe default for new users)
        setQuizCtasHidden(false);
      }
      return true;
    }

    setQuizCtasHidden(!!userState.hasReco);
    return true;
  }

  function positionIntroStrip() {
    var strip = document.querySelector('[data-ppv2-quiz-cta-strip]');
    if (!strip) {
      return;
    }

    var productInfo = strip.closest('product-info');
    var productGrid = productInfo && productInfo.querySelector('.product');
    if (!productInfo || !productGrid || strip.parentElement === productInfo) {
      return;
    }

    productInfo.insertBefore(strip, productGrid);
  }

  function initQuizCtaVisibility() {
    var resolved = applyQuizCtaVisibility();
    if (resolved) {
      return;
    }

    var attempt = 0;
    var maxAttempts = 20;
    var pollId = window.setInterval(function () {
      attempt += 1;
      if (applyQuizCtaVisibility() || attempt >= maxAttempts) {
        window.clearInterval(pollId);
      }
    }, 100);
  }

  function initStickyCta() {
    var mainButton = document.querySelector('[data-ppv2-main-add-button]');
    var sticky = document.querySelector('[data-ppv2-sticky-cta]');

    if (!mainButton || !sticky) {
      return;
    }

    // Reparent sticky element to body to escape transformed ancestor constraint.
    // The theme's animation JS (theme.js) applies transforms to motion-element,
    // which would constrain fixed positioning. Moving to body ensures full viewport width.
    if (sticky.parentElement !== document.body) {
      document.body.appendChild(sticky);
    }

    if (!('IntersectionObserver' in window)) {
      sticky.hidden = false;
      sticky.classList.add('is-visible');
      return;
    }

    sticky.hidden = false;

    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      if (!entry) {
        return;
      }

      // Show the sticky bar only once the main button has scrolled above the
      // viewport (top < 0). isIntersecting alone fires on initial load when
      // the button is simply off-screen below the fold, which would show the
      // bar before the user has ever seen the main button.
      if (entry.isIntersecting) {
        sticky.classList.remove('is-visible');
      } else {
        sticky.classList.toggle('is-visible', entry.boundingClientRect.top < 0);
      }
    }, {
      root: null,
      threshold: 0.2
    });

    observer.observe(mainButton);
  }

  function initPersonalisedPdpV2() {
    bindBundleStateListeners();
    positionIntroStrip();
    initQuizCtaVisibility();
    initStickyCta();
    initVariantPicker();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPersonalisedPdpV2);
  } else {
    initPersonalisedPdpV2();
  }
}());
